import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { Icon } from '@components/icons';
import { useTranslation } from 'react-i18next';

const SuccessUpdatePinModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'update_pin_success'
    });
    return (
        <div className={styles.wrapper}>
            <Icon name="check_outlined" width={80} height={80} />
            <Typography className={styles.title} variant="h4">
                {t('title')}
            </Typography>
        </div>
    );
};

export default SuccessUpdatePinModal;
